/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import { Breadcrumb } from '../Breadcrumb';
import './style.css';

export const HeaderPage = ({
    showSubtitle = true,
    text = 'Subtitle',
    title = 'Page Title H1',
    background,
    breakpoint,
    align,
    className,
    breadcrumbLinkText = 'Materialien',
}) => {
    return (
        <div
            className={`header-page ${className}`}
            data-breakpoint-mode="dekstop"
            data-colors-mode="default"
        >
            <div className="frame-6">
                <Breadcrumb
                    breadcrumb="one-level"
                    className="breadcrumb-instance"
                    linkText={breadcrumbLinkText}
                />
                <div className="page-title">{title}</div>
                {showSubtitle && <div className="subtitle">{text}</div>}
            </div>
        </div>
    );
};

HeaderPage.propTypes = {
    showSubtitle: PropTypes.bool,
    text: PropTypes.object,
    title: PropTypes.string,
    background: PropTypes.oneOf(['default']),
    breakpoint: PropTypes.oneOf(['desktop']),
    align: PropTypes.oneOf(['left']),
    breadcrumbLinkText: PropTypes.string,
};
